import { COOKIE_ACCESS_TOKEN_NAME } from '@connect-x-app/shared-utils';
import Cookies from 'js-cookie';

export const getAccessToken = (): Promise<string | undefined> => {
  const accessToken: string | undefined = Cookies.get(COOKIE_ACCESS_TOKEN_NAME);
  return Promise.resolve(accessToken);
};
